import React, { useEffect, useContext } from "react"
import ExperienceBulletInput from "./experience-bullet-input"
import { ExperienceEditorContext } from "./ExperienceEditorContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons"

const ExperienceBulletsInput = ({ label, placeholders }) => {
  const {
    experience,
    dispatchHighlightAction,
  } = useContext(ExperienceEditorContext)

  const addExtraField = e => {
    e.preventDefault()
    dispatchHighlightAction("CREATE_INPUT_FIELD")
  }

  useEffect(() => {
    dispatchHighlightAction("INITIALIZE_EMPTY_FIELDS")
  }, [])

  return (
    <>
      <label>{label}</label>
      {(experience?.highlights || []).map((highlight, index) => (
        <ExperienceBulletInput
          key={index}
          highlight={highlight}
          index={index}
          placeholder={placeholders[index]}
        />
      ))}
      <button className="experience-bullet-add-button w-shrink-0" onClick={e => addExtraField(e)}>
        <FontAwesomeIcon icon={faPlusCircle} size="lg" color="#40777c" />
      </button>
    </>
  )
}

export default ExperienceBulletsInput
